module.exports = __webpack_public_path__ + "static/img/map.87fcbf7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/map.jpg
// module id = mi+u
// module chunks = 1